import React, { FC, useMemo } from 'react';

import { ITextWithBreakpoints } from '~/interfaces/components/TextWithBreakpoints';

export const makeJSX = (props: ITextWithBreakpoints): JSX.Element[] => {
  const keysArr = Object.keys(props);
  const classes = ['text-with-breakpoints'];
  return Object.values(props).reduce((acc: JSX.Element[], curr: string, i: number) => {
    const key = keysArr[i];
    if (curr) {
      const currentClass = `text-with-breakpoints--${key}`;
      const expectedClasses: string = [...classes, currentClass].join(' ');
      acc.push(
        <span key={key} className={expectedClasses}>
          {curr}
        </span>,
      );
    }
    if (!curr) {
      const lastElIndex: number = acc.length - 1;
      if (lastElIndex >= 0) {
        const currentClass = `text-with-breakpoints--${key}`;
        const previousClasses: string = acc[lastElIndex].props.className;
        const expectedClasses = `${previousClasses} ${currentClass}`;
        const newChildren: string = acc[lastElIndex].props.children;
        acc[lastElIndex] = (
          <span key={keysArr[lastElIndex]} className={expectedClasses}>
            {newChildren}
          </span>
        );
      }
    }
    return acc;
  }, []);
};

const TextWithBreakpoints: FC<ITextWithBreakpoints> = ({
  default: xxs = '',
  xs = '',
  s = '',
  m = '',
  l = '',
  xl = '',
}) => {
  const propsWithDefaults: ITextWithBreakpoints = {
    default: xxs,
    xs,
    s,
    m,
    l,
    xl,
  };
  const returnJSX = useMemo(() => makeJSX(propsWithDefaults).map((el) => el), [propsWithDefaults]);

  return <>{returnJSX}</>;
};

export default TextWithBreakpoints;
